<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('chart', 'top')
const yesterday = dayjs().utc().startOf('day').subtract(1, 'day')
const nowYearMonth = yesterday.startOf('month').format('YYYYMM')
useCustomMeta('chartTop', '', '', '', `/chart/${yesterday.startOf('month').format('YYYY/MM/')}`)
const { data: calendarData } = await useFetch('/api/past/chart/calendar', { query: { start: nowYearMonth } })
const { data: overviewData } = await useFetch('/api/past/overview', { query: { time: nowYearMonth } })
</script>
<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <PastContent
          :calendar-data="calendarData"
          :year="yesterday.startOf('month').format('YYYY')"
          :month="yesterday.startOf('month').format('MM')"
        />
      </div>
      <template #main-bottom>
        <div
          v-if="overviewData.summary"
          class="info"
        >
          <PastOverview :body="overviewData.summary" />
        </div>
      </template>
    </NuxtLayout>
  </div>
</template>
<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
